import axios from "axios";
import baseUrl from "../../environment";

class AuthService {
    login(credential, location, locationString) {
        const formData = new FormData();
        formData.append('username', credential.username);
        formData.append('password', credential.password);
        if (credential.newSession) {
            formData.append('newSession', credential.newSession);
        }
        if (credential.newPassword && credential.newPassword !== '') {
            formData.append('newp', btoa(credential.newPassword));
        }
        if (credential['t&c']) {
            formData.append('t&c', credential['t&c']);
        }
        if (credential['sendSms']) {
            formData.append('sendSms', true);
        }
        if (credential['smsToken']) {
            formData.append('smsToken', credential['smsToken']);
        }
        const url = baseUrl + '/login';
        const options = {
            method: 'POST',
            headers: { 
                'content-type': 'multipart/form-data', 
                'Curr-Loc': location, 
                'CMode': locationString
            },
            data: formData,
            url
        };
        return axios(options);
    }

    logout(location, locationString) {
        const url = baseUrl + '/logout';
        const options = {
            method: 'POST',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
        // return axios.post(baseUrl + '/logout');
    }

    isAuthenticated(location, locationString) {
        const url = baseUrl + '/ping';
        const options = {
            method: 'POST',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
        // return axios.post(baseUrl + "/ping");
    }

    getUsername(location, locationString) {
        const url = baseUrl + '/username';
        const options = {
            method: 'POST',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
        // return axios.post(baseUrl + "/username");
    }

    roleCheck(role, location, locationString) {
        const param = Array.isArray(role) ? "roles" : "role"
        const roleParam = Array.isArray(role) ? role.join() : role;
        const url = baseUrl + "/role_check?" + param + "=" + roleParam;
        const options = {
            method: 'POST',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
        // return axios.post(baseUrl + "/role_check?" + param + "=" + roleParam);
    }

    getRoles(location, locationString) {
        const url = baseUrl + '/_roles';
        const options = {
            method: 'POST',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
        // return axios.post(baseUrl + "/_roles");
    }

    changePassword(credential, location, locationString) {
        const url = baseUrl + '/_cp';
        const options = {
            method: 'POST',
            data: {
                oldPassword: btoa(credential.oldPassword),
                newPassword: btoa(credential.newPassword)
            },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }

    forgotPassword(email, captcha, location, locationString) {
        const url = baseUrl + '/_request_pr_token';
        const options = {
            method: 'POST',
            data: { email: email },
            headers: { 
                'g-recaptcha-response': captcha, 
                'Curr-Loc': location, 
                'CMode': locationString  
            },
            url
        };
        return axios(options);
    }

    resetForgottenPassword(token, password, location, locationString) {
        const url = baseUrl + '/_request_pr';
        const options = {
            method: 'POST',
            data: { token: token, password: btoa(password) },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }

    validateResetPasswordToken(token, location, locationString) {
        const url = baseUrl + '/_validate_token';
        const options = {
            method: 'POST',
            data: { token: token },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }



    // Register
    createNewUser(fullname, username, password, gender, email, phoneNum, dob, passport, passportCountry, ic, incomeRange, broker1, address, addressCity, addressState, addressPost, addressCountry, addressRes, addressResCity, addressResState, addressResPost, addressResCountry, location, locationString) {
        const url = baseUrl + '/user/registration';
        const icContainer = ic && ic !== '' ? {
            ic: ic
        } : "";
        const options = {
            method: 'POST',
            data: { 
                fullname: fullname,
                password: btoa(password),
                gender: gender,
                username: username,
                email: email,
                phoneNum: phoneNum,
                dob: dob,
                passport: passport, 
                passportCountry: passportCountry, 
                ...icContainer,
                incomeRange: incomeRange, 
                broker: broker1, 

                homeAddressLine: address, 
                homeCity: addressCity, 
                homeState: addressState, 
                homePostcode: addressPost, 
                homeCountry: addressCountry, 

                currentAddressLine: addressRes, 
                currentCity: addressResCity, 
                currentState: addressResState, 
                currentPostcode: addressResPost, 
                currentCountry: addressResCountry,
            },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    checkUsername(username, location, locationString) {
        const url = baseUrl + '/user/check/username';
        const options = {
            method: 'POST',
            data: { username: username },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    checkUserEmail(email, location, locationString) {
        const url = baseUrl + '/user/check/email';
        const options = {
            method: 'POST',
            data: { email: email },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    checkPassword(password, location, locationString) {
        const url = baseUrl + '/user/check/password';
        const options = {
            method: 'POST',
            data: { password: btoa(password) },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    checkNRICNumber(ic, location, locationString) {
        const url = baseUrl + '/user/check/ic';
        const options = {
            method: 'POST',
            data: { ic: ic },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    checkPhoneNumber(phoneNum, location, locationString) {
        const url = baseUrl + '/user/check/phonenum';
        const options = {
            method: 'POST',
            data: { phoneNum: phoneNum },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    getAllBroker(location, locationString) {
        const url = baseUrl + '/user/brokers';
        const options = {
            method: 'GET',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    getAllIncomeRange(location, locationString) {
        const url = baseUrl + '/user/incomes';
        const options = {
            method: 'GET',
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    sendEmailVerification(email, location, locationString) {
        const url = baseUrl + '/user/verify/email';
        const options = {
            method: 'POST',
            data: { email: email },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
    verifyUserEmail(token, location, locationString) {
        const url = baseUrl + '/user/_email_verify';
        const options = {
            method: 'POST',
            data: { token: token },
            headers: { 
                'Curr-Loc': location, 
                'CMode': locationString 
            },
            url
        };
        return axios(options);
    }
}

export default AuthService;
